"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = edit;
exports.getBigCatSortList = getBigCatSortList;

var _request = _interopRequireDefault(require("@/utils/request"));

function edit(data) {
  return (0, _request.default)({
    url: 'set-big-cat-sort-list',
    method: 'post',
    data: data
  });
}

function getBigCatSortList(params) {
  return (0, _request.default)({
    url: 'get-big-cat-sort-list',
    method: 'get',
    params: params
  });
}